import mask from 'jquery-mask-plugin';
(function () {

    "use strict";

    //template base do chat
    function chatTemplate(aiOrPerson) {
        return (
            `
    <div class="ai-person-container">
     <span class="${aiOrPerson.class}-date">${aiOrPerson.date}</span><br>
		<div class="${aiOrPerson.class}-icon"></div>
		<div class="${aiOrPerson.class}">
		  <p>${aiOrPerson.text}</p>
		</div>
	  </div>
	`
        );
    }

    //listagem das perguntas fixas
    const responses = [
        "Olá! Qual é o seu nome completo?",
        "Certo, [Nome]. Qual o seu telefone com DDD?",
        "Ok. Agora preciso do seu e-mail.",
        "Qual é o nome da sua empresa?",
        "Obrigado. Para lhe indicar a melhor opção de articulador para sua porta. Qual a LARGURA (em centímetros) da porta onde irá instalar o articulador?",
        "Certo. E qual a ALTURA (em centímetros) da porta onde irá instalar o articulador?",
        "Ok, Por fim, qual a ESPESSURA (em centímetros) da porta onde irá instalar o articulador?",
        "Certo. Segue o resultado de acordo com as medidas informadas:",
    ];

    //variável usada para controlar qual pergunta mostra
    var num = 1;
    var caract = new RegExp(/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/);
    var pesoporta;

    const submit = document.querySelector(".chat-submit");
    const chatBox = document.querySelector(".chat-box");
    const chatInput = document.querySelector(".chat-input");

    //monta o chat inicial
    const date = new Date()
    const timestamp = date.toLocaleTimeString()
    const newChatDiv = chatTemplate({
        class: "ai",
        text: "Olá! Qual é o seu nome completo?",
        date: timestamp
    });
    chatBox.innerHTML += newChatDiv;

    var nome, telefone, email, empresa, altura, largura, espessura, html;
    var message_ajax;


    $('.refazer').click(function (e) {
        $('.refazer').removeClass('d-block').addClass('d-none');
        $('.falar').removeClass('d-block').addClass('d-none');
        num = 4;
        appendChatBox(false);
    });


    //controla o envio do chat no clique de submit
    submit.addEventListener("click", function (e) {
        var email = $('.chat-input').val();

        if (chatInput.name == 'email' && caract.test(email) == false) {
        } else {
            appendChatBox(true);
        }
    });

    //controla o envio do chat ao dar enter
    document.addEventListener("keypress", function (e) {
        var email = $('.chat-input').val();
        if (chatInput.name == 'email' && caract.test(email) == false) {
        } else if (e.keyCode == "13") {
            appendChatBox(true);
        }
    });

    //monta o chat de acordo com a class de pessoa ou "robot"
    function appendChatBox(fromPerson) {
        const date = new Date()
        if (!fromPerson) {
            date.setSeconds(date.getSeconds() + 2)
        }
        if (fromPerson && !chatInput.value.trim() && num != 4) {
            return;
        }
        const timestamp = date.toLocaleTimeString()
        const newChatDiv = chatTemplate({
            class: fromPerson ? "person" : "ai",
            text: fromPerson ? chatInput.value.trim() : aiResponse(),
            date: timestamp
        });
        if (!fromPerson) {
            // make it so it only responds once to multiple fast sentences
            setTimeout(function () {
                chatBox.innerHTML += newChatDiv;
                chatBox.scrollTop = chatBox.scrollHeight;
            }, 2000)
        } else {
            chatBox.innerHTML += newChatDiv;
            chatBox.scrollTop = chatBox.scrollHeight;

            if (chatInput.name == 'nome') {
                nome = chatInput.value;
            } else if (chatInput.name == 'phone') {
                telefone = chatInput.value;
            } else if (chatInput.name == 'email') {
                email = chatInput.value;
            } else if (chatInput.name == 'empresa') {
                empresa = chatInput.value;
            } else if (chatInput.name == 'altura') {
                altura = chatInput.value;
                altura = altura.replace(',', '.').replace(/[^0-9.]/g, '');;
            } else if (chatInput.name == 'largura') {
                largura = chatInput.value;
                largura = largura.replace(',', '.').replace(/[^0-9.]/g, '');;
            } else if (chatInput.name == 'espessura') {
                espessura = chatInput.value;
                espessura = espessura.replace(',', '.').replace(/[^0-9.]/g, '');;
            }

        }
        if (num >= 9) {
            setTimeout(function () {;
                $('.refazer').removeClass('d-none');
                $('.refazer').show();
                chatBox.scrollTop = chatBox.scrollHeight;
            }, 2500)
        }
        if (fromPerson) {
            appendChatBox(false);
        }
    }

    //controla as respostas do "robot"
    function aiResponse() {

        if (num == 1) {
            const response = 'Certo, ' + chatInput.value.trim() + '. Qual o seu telefone com DDD?';
            chatInput.value = "";
            chatInput.type = 'tel';
            chatInput.name = 'phone';
            $(".chat-input").mask("(00) 00000-0000");

            ++num;
            return response;
        }
        else if (num == 2) {
            const response = responses[num];
            chatInput.value = "";
            chatInput.type = 'email';
            chatInput.name = 'email';
            $(".chat-input").unmask();

            ++num;
            return response;
        }
        else if (num == 3) {
            const response = responses[num];
            chatInput.value = "";
            chatInput.type = 'text';
            chatInput.name = 'empresa';
            $(".chat-input").unmask();

            ++num;
            return response;
        }
        else if (num == 4) {
            const response = responses[num];
            chatInput.value = "";
            chatInput.type = 'text';
            chatInput.name = 'largura';
            chatInput.min = null;
            chatInput.max = null;
            $(".chat-input").unmask();

            ++num;
            return response;
        }

        else if (num == 5) {
            const response = responses[num];
            chatInput.value = "";
            chatInput.type = 'text';
            chatInput.name = 'altura';
            $(".chat-input").unmask();

            ++num;
            return response;
        }

        else if (num == 6) {
            const response = responses[num];
            chatInput.value = "";
            chatInput.type = 'text';
            chatInput.name = 'espessura';

            ++num;
            return response;
        }
        else if (num == 7) {
            chatInput.value = "";
            chatInput.type = 'text';
            chatInput.name = 'info';
            
            pesoporta = calcularPeso(altura, largura, espessura)
            const response = recomendacaoArticulador(altura, largura, pesoporta);

            ++num;
            sendData(largura, altura, espessura, pesoporta, nome, telefone, email, empresa)
                .then(function (json) {
                    setTimeout(function () {;
                        $('.refazer, .falar').removeClass('d-none');
                        $('.refazer, .falar').show();
                    }, 2500);
                })
                .catch(function () {
                    setTimeout(function () {;
                        $('.refazer, .falar').removeClass('d-none');
                        $('.refazer, .falar').show();
                    }, 2500);
                });
            return response;
        }
    }

    function calcularPeso(alturaCm, larguraCm, espessuraCm) {
        const densidade = 0.00075; // kg/cm³ (MDF)
        return alturaCm * larguraCm * espessuraCm * densidade;
    }

    function recomendacaoArticulador(altura, largura, peso) {
        altura = Number(altura);
        largura = Number(largura);
        espessura = Number(espessura);

        // altura válida para ambos
        if (altura < 24 || altura > 50) {
            return 'Porta fora dos limites recomendados';
        }

        // 1 articulador
        if (largura >= 30 && largura <= 60 && peso <= 3.5) {
            return 'Recomendamos o uso de 1 articulador';
        }

        // 2 articuladores
        if (largura > 60 && largura <= 120 && peso <= 6) {
            return 'Recomendamos o uso de 2 articuladores';
        }

        return 'Porta fora dos limites recomendados';
    }

    function sendData(largura, altura, espessura, pesoporta, nome, telefone, email, empresa) {
        const message_ajax = 
            'Largura: ' + largura +
            ', Altura: ' + altura +
            ', Espessura: ' + espessura +
            ', Peso: ' + pesoporta;

        const match = document.cookie.match(new RegExp('(^| )__trf.src=([^;]+)'));
        const traffic_source = match ? match[2] : '';

        return $.ajax({
            url: $('#calculadora').attr('data-url'),
            type: 'POST',
            dataType: 'json',
            data: {
                nome,
                telefone,
                email,
                empresa,
                message: message_ajax,
                altura,
                largura,
                espessura,
                peso: pesoporta,
                traffic_source,
                _token: $('meta[name="csrf-token"]').attr('content')
            }
        });
    }

    $('.falar').click(function (e) {
        $('.modalLoader').show();
        $.ajax({
            url: $('#calculadora').attr('data-url'),
            type: 'POST',
            dataType: 'json',
            data: { 'send': true, 'nome': nome, 'telefone': telefone, 'email': email, 'empresa': empresa, 'message': message_ajax, 'peso' : pesoporta, 'altura': altura, 'largura': largura, 'espessura': espessura, '_token': $('meta[name="csrf-token"]').attr('content') },
            async: false,
            error: function () {
                $('.modalLoader').hide();
                Swal.fire({
                    title: jsi18n.ajax_error_title,
                    text: jsi18n.ajax_error_message,
                    imageUrl: site_url + 'site/img/iconError.png',
                    imageWidth: 76,
                    imageHeight: 76
                });
            },
            success: function (json) {
                $('.modalLoader').hide();
                if (json.status) {
                    Swal.fire({
                        title: (json.title) ? json.title : jsi18n.ajax_success_title,
                        html: json.message,
                        imageUrl: site_url + 'site/img/iconSuccess.png',
                        imageWidth: 76,
                        imageHeight: 76
                    });
                } else {
                    Swal.fire({
                        title: json.title,
                        text: json.message,
                        imageUrl: site_url + 'site/img/iconError.png',
                        imageWidth: 76,
                        imageHeight: 76
                    });
                }
            }
        });
    });
}())